export const deriveTenantUsage = (counter, maxCounterLimit) => {
  const rawAvailable = Number(counter);
  const rawLimit = Number(maxCounterLimit);
  const available = Number.isFinite(rawAvailable) ? rawAvailable : 0;
  const limit = Number.isFinite(rawLimit) && rawLimit > 0 ? rawLimit : 0;
  const used = limit ? Math.max(0, limit - available) : 0;
  const overage = Math.max(0, -available);
  const pct = limit ? Math.max(0, Math.min(100, Math.round((used / limit) * 100))) : 0;

  return { available: Math.max(0, available), limit, used, overage, pct };
};
